import {avater} from "../../utils/Constants";
import {imageBaseUrl} from "../../redux/apis/api";


const defaultImgSetup = (profile_pic) => {
    return profile_pic ? imageBaseUrl + profile_pic : avater
};

export default defaultImgSetup;